<!-- Basic form table template this is the base form which is reponsible for rendering all the forms
used as base for building all the CURD datatable form
v1.0
-->
<template>
  <div class="formViewer">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <!-- <div class="headline">FORM NAME</div> -->
        <v-flex lg12>
          <v-btn color="accent" @click="showFormDialog">Add Form</v-btn>
        </v-flex>
        <v-spacer></v-spacer>

        <v-flex lg12>
          <!-- <addDialogSurvey></addDialogSurvey> -->
        </v-flex>
        <!-- table -->
        <v-flex lg12>
          <v-data-table :loading="loading" :headers="headers" :items="userData" class="elevation-1">
            <template v-slot:no-data>
              <v-alert :value="true" color="error" icon="warning">Sorry, nothing to display here :(</v-alert>
            </template>

            <!-- Generate table data based on the header column -->
            <template v-slot:items="props">
              <template v-for="(item, index) in headers">
                <td
                  v-if="item.value != 'action'"
                  v-bind:key="item.value"
                  class="text-xs-center text-ms-center"
                >{{ props.item[''+item.value]}}</td>
              </template>

              <td class="justify-center layout px-0">
                <v-icon small @click="editItem(props.item)" class="mr-2">edit</v-icon>
                <v-icon small class="mr-2" @click="openViewForm(props.item)">remove_red_eye</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- Dialog editor -->
    <v-dialog v-model="dialog" scrollable persistent width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{dialogTitle}}</v-card-title>

        <v-card-text>
          <div id="surveyContainer">
            <survey :survey="addFormSurveyJson"></survey>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeForm">Close</v-btn>
          <v-btn color="primary" v-if="dialogMode == 'ADD'" flat @click="saveForm">Add</v-btn>
          <v-btn color="primary" v-if="dialogMode == 'EDIT'" flat @click="updateForm">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog end -->
  </div>
</template>

<script>
//depecreated this
import addDialogSurvey from "../components/FormViewerSurveyDialog.vue";
import config from "../config.js";

//surveyjs imports
import * as SurveyVue from "survey-vue";
import "bootstrap/dist/css/bootstrap.css";
var Survey = SurveyVue.Survey;
Survey.cssType = "material";
import * as widgets from "surveyjs-widgets";
import "inputmask/dist/inputmask/phone-codes/phone.js";
widgets.icheck(SurveyVue);
widgets.select2(SurveyVue);
widgets.inputmask(SurveyVue);
widgets.jquerybarrating(SurveyVue);
widgets.jqueryuidatepicker(SurveyVue);
widgets.nouislider(SurveyVue);
widgets.select2tagbox(SurveyVue);
widgets.signaturepad(SurveyVue);
widgets.sortablejs(SurveyVue);
widgets.ckeditor(SurveyVue);
widgets.autocomplete(SurveyVue);
widgets.bootstrapslider(SurveyVue);

//backend
const serverHost = config.backendServerHost;

//surveyjs dialogs
var addFormjson = {
  pages: [
    {
      name: "page1",
      elements: [
        {
          type: "text",
          name: "formName",
          startWithNewLine: false,
          title: "Form Name",
          isRequired: true
        },
        {
          type: "text",
          name: "formCode",
          startWithNewLine: false,
          title: "Form code",
          isRequired: true
        },
        {
          type: "dropdown",
          name: "formStatus",
          title: "Form status",
          isRequired: true,
          choices: [
            {
              value: "active",
              text: "active"
            },
            {
              value: "disabled",
              text: "disabled"
            }
          ]
        },
        {
          type: "text",
          name: "version",
          startWithNewLine: false,
          title: "Version",
          isRequired: true,
          inputType: "number"
        },
        {
          type: "comment",
          name: "formSchema",
          title: "Form schema",
          isRequired: true
        }
      ]
    }
  ]
};
var addformModel = new SurveyVue.Model(addFormjson);
addformModel.showNavigationButtons = false; //hide navigation
addformModel.completedHtml = "Saving the data";

export default {
  mounted() {
    this.loadTableForm();

    //surveyjs form listner
    addformModel.onComplete.add(this.surveyOnComplete);
  },

  components: {
    addDialogSurvey,
    Survey
  },
  methods: {
    showFormDialog() {
      this.dialogTitle = "Form";
      this.dialogMode = "ADD";
      this.dialog = true;
    },
    onClickChild(value) {
      console.log(value); // someValue
      //alert(JSON.stringify(value));
      this.userData.push(JSON.parse(value));
    },
    deleteItem(value) {
      this.userData.pop(value);
    },

    openViewForm(value) {
      console.log("route form " + JSON.stringify(value));
      this.$router.push("/dataFormViewer?test=" + value.formCode);
    },

    loadTableForm() {
      //send request
      this.$axios
        .get(serverHost + "/schemas/get/0")
        .then(response => {
          console.log(response);

          if (response.status == 200) {
            console.log("responseLength : " + response.data.data.length);
            //append to data array

            for (
              var arIndex = 0;
              arIndex < response.data.data.length;
              arIndex++
            ) {
              this.userData.push(response.data.data[arIndex]);
              // console.log("dataFromResponse : "+response.data.docs[arIndex]);
            }
            this.loading = false;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    editItem(value) {
      this.dialogTitle = "Edit user";
      this.dialogMode = "EDIT";
      var tmpValues = JSON.parse(JSON.stringify(value)); //clone object
      console.log("editDialog " + JSON.stringify(value));
      addformModel.data = tmpValues;
      this.dialog = true;
    },
    saveDataToServer(value) {
      console.log("saving to server :" + value); // someValue
      //alert(JSON.stringify(value));
      //send request

      this.$axios
        .post(serverHost + "/schemas/insert", value)
        .then(response => {
          console.log(response);
          if (response.status == 200) {
            //parse if status is success or not
            if (response.data.status == "success") {
              this.userData.push(response.data.data);
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    updateDataToServer(value) {
      this.$axios
        .post(serverHost + "/schemas/update", value)
        .then(response => {
          console.log(response);
          if (response.status == 200) {
            //parse if status is success or not
            if (response.data.status == "success") {
              this.loadData();
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    //Dialogs form : Survey js controller
    closeForm: function() {
      //this.saveData(this.form);
      this.dialog = false;
      this.form = {};
      addformModel.clear();
    },
    saveForm: function() {
      addformModel.completeLastPage();
    },
    surveyOnComplete(result) {
      console.log("result " + JSON.stringify(result.data));
      this.dialog = false;

      //save or update the data
      if (this.dialogMode == "EDIT") {
        console.log("EDIT " + result.data);
        this.updateDataToServer(result.data);
      }
      if (this.dialogMode == "ADD") {
        console.log("ADD " + result.data);
        this.saveDataToServer(result.data);
      }
      addformModel.clear();
    },
    updateForm() {
      // this.updateDataToServer(this.form);
      // this.dialog = false;
      // this.form = {};
      addformModel.completeLastPage();
    }
  },
  data() {
    return {
      dialogTitle: "",
      dialogMode: "",
      dialog: false,
      dialog: false,
      loading: true,
      headers: [
        {
          text: "form Name",
          align: "center",
          sortable: false,
          value: "formName"
        },
        { text: "form code", align: "center", value: "formCode" },
        { text: "form status", align: "center", value: "formStatus" },
        { text: "Actions", align: "center", value: "action", sortable: false }
      ],
      userData: [],
      addFormSurveyJson: addformModel
    };
  }
};
</script>
